import { useEffect, useState } from 'react';
import React from 'react';
import './header.css';
import { useTranslation } from "react-i18next";

import header_fondo from '../../../assets/imgs/libro_bitcoin/Landing_section_1_back2-min.jpg';
import header_fondo_mov from '../../../assets/imgs/libro_bitcoin/Landing_section_1_back_mov_prueba_min-low.jpg';

import header_img1 from '../../../assets/imgs/libro_bitcoin/rbs-bitcoin-1-min-low.png';
import header_img2 from '../../../assets/imgs/libro_bitcoin/Rectangle_libro_prueba2.png';


const Header = () => {
    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("libroBitcoin");
    const [imgSrc, setImgSrc] = useState(header_fondo);
    const [isFromMexico, setIsFromMexico] = useState(null);

    const compraInternacional = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Internacional',
            value: 1
        });
    };

    const compraMexico = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Mexico',
            value: 1
        });
    };

    useEffect(() => {
        fetch('https://ipapi.co/json/')
            .then(res => res.json())
            .then(data => {
                console.log("Mexico");
                setIsFromMexico(data.country_code === 'MX');
            })
            .catch(err => {
                console.log("Internacional");
                console.error('Error detecting country:', err);
            });
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setImgSrc(window.innerWidth <= 540 ? header_fondo_mov : header_fondo);
        };

        // Ejecutar al montar
        handleResize();

        // Escuchar cambios de tamaño
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <div class="landing_bitcoin_header">
                {/* <img class="header_bitcoin_img" src={header_img} alt="" />*/}
                <div class="landing_bitcoin_header1">
                    <div class="landing_bitcoin_header_img1">
                        <img class="header_bitcoin_img" src={header_img1} alt="" />
                    </div>
                    <div class="landing_bitcoin_header_content">
                        <div class="landing_bitcoin_header_content-1">
                            <h1 dangerouslySetInnerHTML={{ __html: (t('header.titulo1')) }}></h1>
                        </div>
                        <div class="landing_bitcoin_header_content-2">
                            <h2 dangerouslySetInnerHTML={{ __html: (t('header.content1')) }}></h2>
                            <hr></hr>
                            <h3 dangerouslySetInnerHTML={{ __html: (t('header.content2')) }}></h3>
                            <div class="landing_bitcoin_header_div_buttons">
                                {isFromMexico ? (
                                    <>
                                        <a onClick={compraMexico} href='https://www.elektra.mx/the-bitcoin-enlightenment/p' target='_blank'>{(t('header.btn'))}</a>
                                    </>
                                ) : (
                                    <>
                                        <a onClick={compraMexico} href='https://www.elektra.mx/the-bitcoin-enlightenment/p' target='_blank'>{(t('header.btn1'))}</a>
                                        <a onClick={compraInternacional} href='https://thesaifhouse.com/' target='_blank'>{(t('header.btn2'))}</a>
                                    </>
                                )}

                            </div>
                        </div>
                    </div>
                    <div class="landing_bitcoin_header_img2">
                        <img class="header_bitcoin_img" src={header_img2} alt="" />
                    </div>
                </div>
                <div className='header_bitcoin_title_mov'>
                    <h2 dangerouslySetInnerHTML={{ __html: (t('header.titulo2')) }}></h2>
                </div>
                <img class="header_bitcoin_img_fondo" src={imgSrc} alt="" />
            </div>



        </>
    )
}

export default Header